import { createRoute } from '@tanstack/react-router'
import { mainLayoutRoute } from 'src/layouts/routes'

import { CustomerList } from '../pages/CustomerList/CustomerList'

export const customerRoute = createRoute({
  getParentRoute: () => mainLayoutRoute,
  component: () => <CustomerList />,
  path: '/customer'
})
